import _initializerDefineProperty from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _createClass from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _dec2, _class, _descriptor, _descriptor2;
import "core-js/modules/es.array.concat.js";
import request from '@/utils/request';
import utils from '@/utils/utils';
import { wrapperGet } from '@/utils/http';
import { setRequestConfigDecorator, setRequestHeaderDecorator } from 'decor-core';
import { baseURLConfig, superdiamondEnv } from 'api/common';
export default new (_dec = setRequestConfigDecorator(baseURLConfig), _dec2 = setRequestHeaderDecorator({
  os: 'Android'
}), (_class = /*#__PURE__*/_createClass(function appApi() {
  _classCallCheck(this, appApi);
  /*
   * 获取通用配置文件
   * */
  _initializerDefineProperty(this, "getConfig", _descriptor, this);
  /**
   * 配置接口
   */
  _defineProperty(this, "getAppConfigInfo", wrapperGet('/api/client-ubq-app/config/'));
  /*
   * 获取最新公告
   * */
  _defineProperty(this, "storeNewNotice", wrapperGet('/api/client-ubq-app/store/newNotice'));
  /*
   * 公告列表
   * */
  _defineProperty(this, "storeClientPageNotice", wrapperGet('/api/client-ubq-app/store/clientPageNotice'));
  /*
   * 公告详情
   * */
  _defineProperty(this, "storeNoticeDetail", wrapperGet('/api/client-ubq-app/store/noticeDetail'));
  /*
   * 获取APP下载地址
   * */
  _initializerDefineProperty(this, "getApp", _descriptor2, this);
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "getConfig", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet("/superdiamond/preview/ibmarket/publicity/".concat(superdiamondEnv, "?format=json"));
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "getApp", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/opubq/system/app');
  }
})), _class))();

// 获取哈希地址（用于上传Obs)
export function hashUpload(mun) {
  var bucketName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils.Config.bucketName;
  return request({
    url: "/api/opservcenter/opsc/obsFile/generateQuantitativeFileHash/".concat(mun, "?bucketName=").concat(bucketName),
    method: 'get'
  });
}

// 通用新增
export function shareNormalAdd(data) {
  return request({
    url: '/api/client-ubq-app/vote/leaveMessage',
    method: 'post',
    data: data
  });
}

// 通用查询
export function shareNormalQuery(data) {
  return request({
    url: '/api/opservcenter/normalScene/shareNormalQuery',
    method: 'post',
    data: data
  });
}